module.exports = "/_next/static/images/img-super-benefit-4-0d6cd469d91414234d4513b8cd7fe11b.svg";